import { render, staticRenderFns } from "./architecture.vue?vue&type=template&id=a3112264&scoped=true&"
import script from "./architecture.vue?vue&type=script&lang=js&"
export * from "./architecture.vue?vue&type=script&lang=js&"
import style0 from "./architecture.vue?vue&type=style&index=0&id=a3112264&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3112264",
  null
  
)

export default component.exports